import { ResizeFitModeEnum } from '../constants/cms-constants';

export function getResizeFitMode(resizeFitMode) {
  if (resizeFitMode === undefined) {
    return 'crop';
  }

  let fitMode: string;
  switch (resizeFitMode.toLowerCase()) {
    case ResizeFitModeEnum.CLAMP:
      fitMode = 'clamp';
      break;
    case ResizeFitModeEnum.CLIP:
      fitMode = 'clip';
      break;
    case ResizeFitModeEnum.FACEAREA:
      fitMode = 'facearea';
      break;
    case ResizeFitModeEnum.FILL:
      fitMode = 'fill';
      break;
    case ResizeFitModeEnum.FILLMAX:
      fitMode = 'fillmax';
      break;
    case ResizeFitModeEnum.MAX:
      fitMode = 'max';
      break;
    case ResizeFitModeEnum.MIN:
      fitMode = 'min';
      break;
    case ResizeFitModeEnum.SCALE:
      fitMode = 'scale';
      break;
    default:
      fitMode = 'crop';
  }
  return fitMode;
}

export default getResizeFitMode;
